export default __webpack_public_path__ + "b1b46571aff2d47d4ea214719565aec7.png";